import SignaturePicker from "components/signature-picker";

type SignDocumentDialogProps = {
  show?: boolean;
  enableHandSignatureOnly?: boolean;
  onClose: () => void;
  onSubmit?: (files: File[]) => Promise<void>;
};

export default function SignDocumentDialog({
  show,
  enableHandSignatureOnly,
  onClose,
  onSubmit
}: SignDocumentDialogProps) {
  return (
    <SignaturePicker
      title="Sign Document"
      submitButtonName="Sign Document"
      open={Boolean(show)}
      onClose={onClose}
      onSubmit={onSubmit}
      hasInitialImage={false}
      largeSize
      enableHandSignatureOnly={enableHandSignatureOnly}
    />
  );
}
